export default __webpack_public_path__ + "static/media/emoji-rocket-down.b681f5ff.svg";